module.exports = __webpack_public_path__ + "img/bg-logo.b17215d1.svg";